<template>
    <div role="status" aria-label="Voice input suggestion" class="relative flex items-center gap-3 rounded-xl border-2 border-[#E8E8E8] bg-white px-5 py-3 pr-9 w-full">
        <button
            type="button"
            aria-label="Switch to voice input"
            class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-valence-primary-500 animate-mic-pulse cursor-pointer hover:bg-valence-primary-600 transition-colors"
            @click="emit('activate-voice')">
            <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
            </svg>
        </button>
        <p class="flex-1 body-small text-valence-grey-750">{{ content }}</p>
        <button
            type="button"
            aria-label="Dismiss voice suggestion"
            class="bi bi-x absolute top-1.5 right-1.5 flex items-center justify-center h-7 w-7 rounded-full text-2xl leading-none text-valence-grey-400 hover:text-valence-grey-600 hover:bg-valence-grey-100 transition-colors cursor-pointer"
            @click="emit('dismiss')"></button>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    content: string;
}>();

const emit = defineEmits<{
    dismiss: [];
    "activate-voice": [];
}>();
</script>

<style scoped>
.animate-mic-pulse {
    animation: mic-pulse 2s ease-in-out 0.5s 3;
}

@keyframes mic-pulse {
    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(85, 91, 162, 0.4);
    }
    50% {
        box-shadow: 0 0 0 6px rgba(85, 91, 162, 0);
    }
}
</style>
